<template>
  <div>
    <div class="d-flex align-center mb-4">
      <page-title :value="$t('schoolService.title')" />
      <v-spacer />
      <div style="width: 160px" class="mx-2">
        <v-text-field
          hide-details
          density="compact"
          variant="outlined"
          type="number"
          v-model.number="year"
          :suffix="$t('common.schoolYear')"
        ></v-text-field>
      </div>
      <div class="mx-2">
        <school-service-edit-container />
      </div>
      <div class="mx-2">
        <school-service-create-container />
      </div>
    </div>

    <div class="mb-8">
      <v-tabs v-model="tab" color="primary">
        <v-tab value="daily">{{ $t('schoolService.perUsage') }}</v-tab>
        <v-tab value="monthly">{{ $t('schoolService.fixedMonthly') }}</v-tab>
      </v-tabs>

      <v-window v-model="tab" class="mt-4">
        <v-window-item value="daily">
          <school-service-daily-contianer />
        </v-window-item>
        
        <v-window-item value="monthly">
          <school-service-monthly-container />
        </v-window-item>
      </v-window>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import PageTitle from "@/components/atoms/PageTitle.vue";
import SchoolServiceCreateContainer from "@/containers/school-service/SchoolServiceCreateContainer.vue";
import SchoolServiceEditContainer from "@/containers/school-service/SchoolServiceEditContainer.vue";
import SchoolServiceDailyContianer from "@/containers/school-service/SchoolServiceDailyContianer.vue";
import SchoolServiceMonthlyContainer from "@/containers/school-service/SchoolServiceMonthlyContainer.vue";
import dayjs from "dayjs";
import LocalDataService from "@/service/LocalDataService";
import CommonUtil from "@/utils/CommonUtil";
import { classModule } from "@/store/dataModules/classModule";

interface DataType {
  year: number;
  tab: string; // タブの状態を管理する変数の型を追加
}

export default defineComponent({
  components: {
    PageTitle,
    SchoolServiceDailyContianer,
    SchoolServiceCreateContainer,
    SchoolServiceEditContainer,
    SchoolServiceMonthlyContainer,
  },
  
  data: (): DataType => ({
    year: dayjs().year(),
    tab: 'daily', // 初期表示したいタブの value をセット
  }),
  
  methods: {
    listClasses() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        classModule.listClass({
          nurseryId: nurseryId,
          year: this.year,
        });
      }
    },
  },
  
  watch: {
    year() {
      this.listClasses();
    },
  },
  
  async mounted() {
    this.year = parseInt(CommonUtil.getFiscalYear(dayjs().format("YYYY-MM")));
    this.listClasses();
  },
});
</script>